(() => {
  const dialog = document.querySelector('[data-store-regions]');
  if (!dialog || !dialog.showModal) return;
  const entryParameter = 'choose-store';
  const entryPendingKey = 'sothing-region-entry-pending';
  const entryUrl = new URL(window.location.href);
  let shouldOpenFromMainSite = entryUrl.searchParams.get(entryParameter) === '1';
  if (shouldOpenFromMainSite) {
    try { sessionStorage.setItem(entryPendingKey, '1'); } catch {}
    entryUrl.searchParams.delete(entryParameter);
    history.replaceState(history.state, '', entryUrl.pathname + entryUrl.search + entryUrl.hash);
  } else {
    try { shouldOpenFromMainSite = sessionStorage.getItem(entryPendingKey) === '1'; } catch {}
  }
  const tabs = [...dialog.querySelectorAll('[data-region]')];
  const form = dialog.querySelector('form');
  let opener;
  const select = tab => {
    tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
    const us = tab.dataset.region === 'United States';
    dialog.querySelector('[data-region-us]').hidden = !us;
    dialog.querySelector('[data-region-soon]').hidden = us;
    dialog.querySelector('[data-region-name]').textContent = tab.dataset.region;
    dialog.querySelector('#sr-panel').setAttribute('aria-labelledby', tab.id);
  };
  const open = trigger => { opener = trigger; select(tabs[0]); if (!dialog.open) dialog.showModal(); };
  document.querySelectorAll('[data-region-open]').forEach(button => button.addEventListener('click', () => open(button)));
  dialog.querySelector('[data-region-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { opener?.focus(); });
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', event => {
      let next;
      if (['ArrowDown','ArrowRight'].includes(event.key)) next = (index + 1) % tabs.length;
      if (['ArrowUp','ArrowLeft'].includes(event.key)) next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); select(tabs[next]); tabs[next].focus(); }
    });
  });
  dialog.querySelector('[data-region-back]').addEventListener('click', () => { select(tabs[0]); tabs[0].focus(); });
  form.addEventListener('submit', event => {
    try { sessionStorage.removeItem(entryPendingKey); } catch {}
    if (document.documentElement.lang === 'en' && document.body.dataset.storeCountry === 'US') { event.preventDefault(); dialog.close(); }
  });
  // Preserve the actual page and edition when resetting a prior non-US session.
  form.querySelector('[name=return_to]').value = location.pathname + location.search;
  if (document.body.dataset.storeCountry !== 'US' || document.documentElement.lang !== 'en') {
    const key = 'sothing-region-reset:' + location.pathname;
    try { if (!sessionStorage.getItem(key)) { sessionStorage.setItem(key, '1'); form.requestSubmit(); return; } } catch {}
  }
  if (shouldOpenFromMainSite) {
    try { sessionStorage.removeItem(entryPendingKey); } catch {}
    open();
  }
})();
